
<span mat-button mat-dialog-close class="right pointer"><i id="closeOverlay" class="far fa-times-circle"></i></span>
<h1 mat-dialog-title>Nuova consegna From Business</h1>
<div mat-dialog-content>
  <form class="has-cols" [formGroup]="businessSaleForm" (ngSubmit)="onSubmit()" *ngIf="businessSaleForm">
    <div class="delivery-colle-data-box">
      <fieldset>
        <legend>SCELTA DEL SERVIZIO:</legend>

        <div class="col-40 grid-element">
          <label>Data consegna{{ businessSaleForm.get("deliveryDate") | required }}</label>
          <input type="date" formControlName="deliveryDate">
          <app-error-html-handler [ctrl]="businessSaleForm.get('deliveryDate')" [messages]="formValidationMsgs.deliveryDate">
          </app-error-html-handler>
        </div>

        <div class="grid-element-full">
          <label>Indirizzo destinatario{{ businessSaleForm.get("address") | required }}
            <span class="directions" (click)="directions($event)"> <i class="fas fa-directions fa-2x"></i></span>
          </label>
          <app-google-maps-search (setAddress)="getAddress($event)" addressType="geocode" [control]="businessSaleForm.get('address')"></app-google-maps-search>
          <app-error-html-handler [ctrl]="businessSaleForm.get('address')" [messages]="formValidationMsgs.address"></app-error-html-handler>
        </div>

        <div class="col-40 grid-element">
          <label></label>
          <input type="hidden">
        </div> 
        <br class="clear">

        <div class="col-48 grid-element" *ngIf="(groups.includes('admin') || groups.includes('operation'))" formGroupName="partner">
          <label>Partner</label>
          <!-- <select id="selezionePartner" type="text" formControlName="id" (change)="handlePartnerChange($event.target.value)"> -->
            <select id="selezionePartner" type="text" formControlName="id" (change)="handlePartnerChangeDropDown($event.target.value)">
            <option value="null" selected disabled></option>
            <option *ngFor="let partner of partners" [value]="partner.id">{{partner.businessName}}</option>
          </select>
        </div>
        
        <div class="col-48 grid-element">
          <label>Servizio{{ businessSaleForm.get('service') | required }}</label>
          <select name="" id="" (change)=handleServiceChange($event.target.value) formControlName="service">
            <!-- <option [selected]="true" [disabled]="true"></option> -->
            <option value="null" [selected]="true" [disabled]="true"></option>
            <option value="{{service?.service?.id}}" *ngFor="let service of selectedPartnerServices" [disabled]="service?.service?.pricingModel === 'sales' && groups.includes('partner')">{{service?.service?.serviceName}}</option>
          </select>
          <app-error-html-handler [ctrl]="businessSaleForm.get('service')"
            [messages]="formValidationMsgs.service">
          </app-error-html-handler>
        </div>

        <!-- New Version of start and end time -->
        <div class="col-48 grid-element" *ngIf="showStartEndTime">
          <label>Start and End Time</label>
          <div class="time-range">
            <div>
              <input type="time" formControlName="startTime" (change)="handleStartTimeChange($event.target.value)">
            </div>
            <div style="text-align: center;">&nbsp;-&nbsp;</div>
            <div>
              <input type="time" formControlName="endTime" (change)="handleEndTimeChange($event.target.value)">
            </div>
          </div>
        </div>
        <!-- New Version of start and end time -->


      </fieldset>
    </div>

    <!--
    <div class="order-management-box" style="margin-top: 15px;">
      <fieldset>
        <legend>GESTIONE DELL'ORDINE:</legend>

        <div class="col-48 grid-element">
          <label for="payAtDelivery"></label>
          <label class="original-label">
            <input type="checkbox" name="payAtDelivery" formControlName="payAtDelivery">
            Pagamento alla consegna
          </label>
        </div>

        <div class="col-48 grid-element" [ngClass]="{'hidden': !businessSaleForm.get('payAtDelivery').value}" *ngIf="groups.includes('admin') || groups.includes('operation')">
          <label>Pagamento alla consegna prezzo{{ businessSaleForm.get("payAtDeliveryAmount") | required }}</label>
          <input type="text" formControlName="payAtDeliveryAmount">
          <app-error-html-handler [ctrl]="businessSaleForm.get('payAtDeliveryAmount')" [messages]="formValidationMsgs.payAtDeliveryAmount"> 
          </app-error-html-handler>
        </div>

        <div class="col-48 grid-element">
          <label for="tryAndReturn"></label>
          <label class="original-label">
            <input type="checkbox" name="tryAndReturn" formControlName="tryAndReturn">
            Prova e reso del prodotto
          </label>
        </div>

        <div class="grid-element-full">
          <label>Prodotto{{ businessSaleForm.get('deliveryProducts').controls[0].controls.product.id | required }}*</label>
          <div formArrayName="deliveryProducts">
            <div class="offer-products"
              *ngFor="let productForm of businessSaleForm.get('deliveryProducts').controls; let i = index">
              <div [formGroupName]="i" class="mb-5" style="display: table; width: 100%;">
                <div style="display: table-cell; width: 19px;">
                  <i class="far fa-times-circle hvr-grow remove-product"  (click)="removeProduct(i)"></i>
                </div>
                <div class="product-q" formGroupName="product">
                  <div class="porduct-qty">
  
                    <div class="main-product">
                       <ng-select bindLabel="name" bindValue="id" formControlName="id" (change)="handleProductChange(i, $event)">
                        <ng-option *ngFor="let product of productss | sortProducts:selectedPartner?.id" [value]="product.id" [disabled]="isOptionDisabled(product)">
                          <b *ngIf="product?.partner?.id == selectedPartner?.id">{{ product.name }}</b>
                          <span *ngIf="product?.partner?.id != selectedPartner?.id || !product?.partner">{{ product.name }}</span>
                        </ng-option>
                      </ng-select>
                    </div>
    
                    <div class="product-quantity">
                       <input type="number" formControlName="quantity" placeholder="Product quantity" (input)="handleProductQuantityChange()">
                    </div>

                    <div *ngIf="showProductImage[i]">
                      <img [src]='productImageUrls[i]' alt="" height="50" width="60">
                    </div>
                  </div>
                </div>
                <fieldset class="variant-fieldset" *ngIf="showProductVariant[i]">
                  <legend><b>{{ selectedProductsForVariants[i]?.productOptionTitle?.toUpperCase() }}</b></legend>
                  <div class="product-variants">
                    <span 
                      class="chip primary"
                      [ngClass]="{ 'variant-selected': variant === selectedVariants[i] }"
                      *ngFor="let variant of selectedProductsForVariants[i]?.productVariants"
                      (click)="onVariantSelect(i, variant)"
                    >
                      {{ variant?.variantName || "---"}}
                    </span>
                  </div>
                </fieldset>
                <br>
                <app-error-html-handler [ctrl]="productForm.controls.product.controls.id"
                  [messages]="formValidationMsgs.deliveryProducts.product.id">
                </app-error-html-handler>
              </div>
            </div>
          </div>
          <div class="center" style="width: 100%;">
            <button type="button" class="btn mt-0" (click)="$event.preventDefault(); addProduct()">
              Aggiungi prodotto<i class="ml-10 fas fa-plus"></i>
            </button>
          </div>
        </div>

      </fieldset>
    </div>
    -->

    <div class="order-management-box" style="margin-top: 15px;">
      <fieldset>
        <legend>GESTIONE DELL'ORDINE:</legend>
        
        <div style="margin-bottom: 10px; margin-top: 15px;">
          <fieldset >
            <legend>OPZIONI DEL PRODOTTO</legend>
            <div class="col-48 grid-element">
              <label for="payAtDelivery"></label>
              <label class="original-label">
                <input type="checkbox" name="payAtDelivery" formControlName="payAtDelivery">
                Pagamento alla consegna
              </label>
            </div>

            <div class="col-48 grid-element" [ngClass]="{'hidden': !businessSaleForm.get('payAtDelivery').value}" *ngIf="groups.includes('admin') || groups.includes('operation')">
              <label>Pagamento alla consegna prezzo{{ businessSaleForm.get("payAtDeliveryAmount") | required }}</label>
              <input type="text" formControlName="payAtDeliveryAmount">
              <app-error-html-handler [ctrl]="businessSaleForm.get('payAtDeliveryAmount')" [messages]="formValidationMsgs.payAtDeliveryAmount"> 
              </app-error-html-handler>
            </div>
      
            <div class="col-48 grid-element">
              <label for="tryAndReturn"></label>
              <label class="original-label">
                <input type="checkbox" name="tryAndReturn" formControlName="tryAndReturn">
                Prova e reso del prodotto
              </label>
            </div>
            
            <div class="col-48 grid-element">
              <label for="isFlexiblePrice"></label>
              <label class="original-label">
                <input type="checkbox" name="isFlexiblePrice" formControlName="isFlexiblePrice" (change)="handleFlexiblePayment($event)">
                Prezzo flessibile
              </label>
            </div>
          </fieldset>
        </div>
  
        <div style="margin-bottom: 10px; margin-top: 15px;">
          <div formArrayName="deliveryProducts">
            <div class="offer-products" *ngFor="let productForm of businessSaleForm.get('deliveryProducts').controls; let i = index">
              <fieldset style="margin-bottom: 10px; margin-top: 15px;">
                <legend>PRODOTTO & QUANTITA</legend>
                <div [formGroupName]="i" class="mb-5" style="display: table; width: 100%;">
                  <div style="display: table-cell; width: 19px;">
                    <i class="far fa-times-circle hvr-grow remove-product"  (click)="removeProduct(i)"></i>
                  </div>
                  <div class="product-q" formGroupName="product">
                    <div class="porduct-qty">
                      <div class="grid-element-full-product">
                        <label for="product">Prodotto {{ businessSaleForm.get('productForm.controls.product.controls.id') }}</label>
                        <ng-select 
                          bindLabel="name" 
                          bindValue="id" 
                          formControlName="id" 
                          (change)="handleProductChange(i, $event)"
                          [searchable]="true" 
                          [clearable]="true"
                          [virtualScroll]="true"
                        >
                          <ng-option *ngFor="let product of productss | sortProducts:selectedPartner?.id" [value]="product.id" [disabled]="isOptionDisabled(product)" >
                            <b *ngIf="product?.partner?.id == selectedPartner?.id">{{ product.name }}</b>
                            <span *ngIf="product?.partner?.id != selectedPartner?.id || !product?.partner">{{ product.name }}</span>
                          </ng-option>
                        </ng-select>
                        <app-error-html-handler [ctrl]="productForm.controls.product.controls.id"
                          [messages]="formValidationMsgs.deliveryProducts.product.id">
                        </app-error-html-handler>
                      </div>

                      <div class="col-48 grid-element">
                        <label for="">Flessibile Prezzo</label>
                        <input 
                          type="number" 
                          step="0.01" 
                          min="0" 
                          formControlName="flexiblePrice"
                          [disabled]="businessSaleForm.get('isFlexiblePrice').value === false" 
                          [readonly]="businessSaleForm.get('isFlexiblePrice').value === false"
                          (input)="handleManualPriceUpdate(i, $event.target.value)"
                        >
                      </div>
      
                      <div class="col-48 grid-element">
                        <label for="quantity">Quantità</label>
                        <input type="number" formControlName="quantity" placeholder="Prodotto Quantità" (input)="handleProductQuantityChange()">
                        <app-error-html-handler [ctrl]="productForm.controls.product.controls.quantity"
                          [messages]="formValidationMsgs.deliveryProducts.product.quantity">
                        </app-error-html-handler>
                      </div>

                      <div *ngIf="showProductImage[i]" class="product-image-wrapper">
                        <img [src]='productImageUrls[i]' class="product-image" alt="" height="50" width="60">
                      </div>
                    </div>
                  </div>
                  <fieldset class="variant-fieldset" *ngIf="showProductVariant[i]">
                    <legend><b>{{ selectedProductsForVariants[i]?.productOptionTitle?.toUpperCase() }}</b></legend>
                    <div class="product-variants">
                      <span 
                        class="chip primary"
                        [ngClass]="{ 'variant-selected': variant === selectedVariants[i] }"
                        *ngFor="let variant of selectedProductsForVariants[i]?.productVariants"
                        (click)="onVariantSelect(i, variant)"
                      >
                        {{ variant?.variantName || "---"}}
                      </span>
                    </div>
                  </fieldset>
                </div>
              </fieldset>
            </div>
          </div>
          <div class="center" style="width: 100%;">
            <button type="button" class="btn mt-0" (click)="$event.preventDefault(); addProduct()">
              Aggiungi prodotto<i class="ml-10 fas fa-plus"></i>
            </button>
          </div>
        </div>
      </fieldset>
    </div>

    <div class="delivery-colle-data-box" style="margin-top: 15px;">
      <fieldset>
        <legend>DATA DI CONSEGNA E RITIRO:</legend>
        <div class="col-48 grid-element" *ngIf="showPickUpAddress || showProductValue">
          <label>Disponibilità expert{{ businessSaleForm.get("requestExpert") | required }}</label>
          <label class="original-label">
            <input type="checkbox" formControlName="requestExpert">
            Consegna Flessibile
          </label>
        </div>

        <div class="col-48 grid-element" *ngIf="!showStartEndTime">
          <label>FASCIA ORARIA CONSEGNA</label>
          <div class="time-range" [ngClass]="{'hidden': !!businessSaleForm.get('requestExpert').value}">
            <div>
              <select (change)=setTime($event.target.value)>
                <option></option>
                <option *ngFor="let item of timePeriods | enumToArray" [value]="item.index"
                  [selected]="businessSaleForm.get('fromTime').value == item.name.from && businessSaleForm.get('toTime').value == item.name.to">
                  {{item.index}}
                </option>
              </select>
            </div>
          </div>
          <div class="time-range" [ngClass]="{'hidden': !businessSaleForm.get('requestExpert').value}">
            <div>
              <input type="time" formControlName="fromTime">
              <app-error-html-handler [ctrl]="businessSaleForm.get('fromTime')" [messages]="formValidationMsgs.fromTime">
              </app-error-html-handler>
            </div>
            <div style="text-align: center;">&nbsp;-&nbsp;</div>
            <div>
              <input type="time" formControlName="toTime">
              <app-error-html-handler [ctrl]="businessSaleForm.get('toTime')" [messages]="formValidationMsgs.toTime">
              </app-error-html-handler>
            </div>
          </div>
        </div>
        <br class="clear">

        <div class="col-48 grid-element">
          <label></label>
          <label class="original-label">
            <input type="checkbox" formControlName="isFlexblePickUpTime">
            Flessibile Fascia Oraria Ritiro
          </label>
        </div>

        <div class="col-48 grid-element" *ngIf="groups.includes('admin') || groups.includes('partner') || groups.includes('operation')">
          <label>FASCIA ORARIA RITIRO</label>
          <div class="time-range" [ngClass]="{'hidden': !!businessSaleForm.get('isFlexblePickUpTime').value}">
            <div>
              <select formControlName="pickUpTime">
                <option value="06:00-07:00">06:00-07:00</option>
                <option value="07:00-08:00">07:00-08:00</option>
                <option value="08:00-09:00">08:00-09:00</option>
                <option value="09:00-10:00">09:00-10:00</option>
                <option value="10:00-11:00">10:00-11:00</option>
                <option value="11:00-12:00">11:00-12:00</option>
                <option value="12:00-13:00">12:00-13:00</option>
                <option value="13:00-14:00">13:00-14:00</option>
                <option value="14:00-15:00">14:00-15:00</option>
                <option value="15:00-16:00">15:00-16:00</option>
                <option value="16:00-17:00">16:00-17:00</option>
                <option value="17:00-18:00">17:00-18:00</option>
                <option value="18:00-19:00">18:00-19:00</option>
                <option value="19:00-20:00">19:00-20:00</option>
                <option value="20:00-21:00">20:00-21:00</option>
                <option value="21:00-22:00">21:00-22:00</option>
              </select>
            </div>
          </div>
          <div class="time-range" [ngClass]="{'hidden': !businessSaleForm.get('isFlexblePickUpTime').value}">
            <div>
              <input type="time" [(ngModel)]="pickUpFTime" [ngModelOptions]="{standalone: true}" (ngModelChange)="handlePickUpFlexbleTime()">
              <app-error-html-handler [ctrl]="businessSaleForm.get('fromTime')" [messages]="formValidationMsgs.fromTime">
              </app-error-html-handler>
            </div>
            <div style="text-align: center;">&nbsp;-&nbsp;</div>
            <div>
              <input type="time" [(ngModel)]="pickUpTTime" [ngModelOptions]="{standalone: true}" (ngModelChange)="handlePickUpFlexbleTime()">
              <app-error-html-handler [ctrl]="businessSaleForm.get('toTime')" [messages]="formValidationMsgs.toTime">
              </app-error-html-handler>
            </div>
          </div>
        </div>

        <!-- No Longer Needed -->
        <div class="col-48 grid-element hidden"  *ngIf="groups.includes('admin') || groups.includes('operation')">
          <label for="deluxyDelivery"></label>
          <label class="original-label">
            <input type="checkbox" name="deluxyDelivery" formControlName="deluxyDelivery">
            Vendita Deluxy
          </label>
        </div>  
        <!-- No Longer Needed -->

      </fieldset>
    </div>

    <div class="expert-salary-section" style="margin-top: 15px;" *ngIf="groups.includes('admin') || groups.includes('operation')">
      <fieldset>
        <legend>SCELTA DEL SALARIO:</legend>

        <div class="col-48 grid-element" formGroupName="expert">
          <label>Valet{{ businessSaleForm.get('expert').get('id') | required }}</label>
          <select id="selezioneExpert" type="text" formControlName="id" (change)=setDeliveryStatus($event.target.value)>
            <option disabled></option>
            <option *ngFor="let expert of experts" [value]="expert.id">{{expert.user.surname}}
              {{expert.user.name}}</option>
          </select>
          <app-error-html-handler [ctrl]="businessSaleForm.get('expert').get('id')"
            [messages]="formValidationMsgs.expert.id">
          </app-error-html-handler>
        </div>
        
        <div class="col-48 grid-element">
          <label>Stato consegna{{ businessSaleForm.get("status") | required }}</label>
          <select formControlName="status">
            <option value="null" selected disabled></option>
            <option *ngFor="let item of deliveryStatus | enumToArray" value="{{item.name}}">
              {{deliveryStatusAux.ln('it', item.name)}}
            </option>
          </select>
          <app-error-html-handler [ctrl]="businessSaleForm.get('status')" [messages]="formValidationMsgs.status">
          </app-error-html-handler>
        </div>  

        <div class="col-48 grid-element" *ngIf="groups.includes('admin') || groups.includes('operation')">
          <label>Valet Servizio</label>
          <select formControlName="expertServiceId" (change)="handleValetServiceChange($event.target.value)">
            <option value="null" selected disabled></option>
            <option value="{{service?.id}}" *ngFor="let service of selectedExpertServices">{{service?.service?.serviceName}}</option>
          </select>
          <app-error-html-handler [ctrl]="businessSaleForm.get('status')" [messages]="formValidationMsgs.status">
          </app-error-html-handler>
        </div>

        <!-- Start and end time for calculate expert salary -->
        <div class="col-48 grid-element" *ngIf="showValetStartAndEndTime && (groups.includes('admin') || groups.includes('operation'))">
          <label>Valet Start and End Time</label>
          <div class="time-range">
            <div>
              <input type="time" formControlName="valetStartTime" (change)="handleValetStartTimeChange($event.target.value)">
            </div>
            <div style="text-align: center;">&nbsp;-&nbsp;</div>
            <div>
              <input type="time" formControlName="valetEndTime" (change)="handleValetEndTimeChange($event.target.value)">
            </div>
          </div>
        </div>
        <!-- Start and end time for calculate expert salary -->

      </fieldset>
    </div>
     
    <div class="recipient-sender-info-box" style="margin-top: 15px;">
      <fieldset>
        <legend>INFORMAZIONI DESTINATARIO E MITTENTE:</legend>

        <div class="col-48 grid-element" *ngIf="groups.includes('admin') || groups.includes('operation')">
          <label>SMS telefonici</label>
          <input type="text" placeholder="+449878487878" formControlName="smsPhoneNo">
          <app-error-html-handler [ctrl]="businessSaleForm.get('smsPhoneNo')"
            [messages]="formValidationMsgs.receiverPhone">
          </app-error-html-handler>
        </div>
        <br class="clear">

        <div class="col-48 grid-element">
          <label>Cognome destinatario{{ businessSaleForm.get("surname") | required }}</label>
          <input type="text" formControlName="surname">
          <app-error-html-handler [ctrl]="businessSaleForm.get('surname')" [messages]="formValidationMsgs.surname">
          </app-error-html-handler>
        </div>

        <div class="col-48 grid-element">
          <label>Nome destinatario{{ businessSaleForm.get("name") | required }}</label>
          <input type="text" formControlName="name">
          <app-error-html-handler [ctrl]="businessSaleForm.get('name')" [messages]="formValidationMsgs.name">
          </app-error-html-handler>
        </div>

        <!--
        <div class="grid-element-full">
          <label>Indirizzo destinatario{{ businessSaleForm.get("address") | required }}
            <span class="directions" (click)="directions($event)"> <i class="fas fa-directions fa-2x"></i></span>
          </label>
          <app-google-maps-search (setAddress)="getAddress($event)" addressType="geocode" [control]="businessSaleForm.get('address')"></app-google-maps-search>
          <app-error-html-handler [ctrl]="businessSaleForm.get('address')" [messages]="formValidationMsgs.address"></app-error-html-handler>
        </div>
        -->

        <div class="col-48 grid-element">
          <label>Citofono{{ businessSaleForm.get("intercom") | required }}</label>
          <input type="text" formControlName="intercom">
          <app-error-html-handler [ctrl]="businessSaleForm.get('intercom')" [messages]="formValidationMsgs.intercom"></app-error-html-handler>
        </div>

        <div class="col-48 grid-element">
          <label>Telefono destinatario</label>
          <input type="text" placeholder="+449878487878" formControlName="receiverPhone">
          <app-error-html-handler [ctrl]="businessSaleForm.get('receiverPhone')"
            [messages]="formValidationMsgs.receiverPhone">
          </app-error-html-handler>
        </div>

        <div class="col-48 grid-element">
          <label>Email destinatario</label>
          <input type="text" formControlName="email">
        </div>
        <div class="col-48 grid-element">
          <label>Cognome mittente</label>
          <input type="text" formControlName="senderSurname">
        </div>

        <div class="col-48 grid-element">
          <label>Nome mittente</label>
          <input type="text" formControlName="senderName">
        </div>
        <div class="col-48 grid-element">
          <label>Telefono mittente</label>
          <input type="text" formControlName="senderPhone">
          <app-error-html-handler [ctrl]="businessSaleForm.get('senderPhone')"
            [messages]="formValidationMsgs.senderPhone">
          </app-error-html-handler>
        </div>
      </fieldset>
    </div>
    <br class="clear">

    <div class="list" style="margin-top: 15px;">
      <fieldset>
        <legend>LISTINO:</legend>
        <!--Billable field-->
        <div class="col-48 grid-element" *ngIf="(groups.includes('admin') || groups.includes('operation'))">
          <label for="billable"></label>
          <label class="original-label">
            <input type="checkbox" name="billable" formControlName="billable" (change)="handleBillable($event)">
            DA FATTURARE
          </label>
        </div>
        <!--Billable field-->
       
        <div class="grid-element-full">
          <label>
            Indirizzo di Ritiro
            <span class="directions" (click)="pickUpDirections($event)"> <i class="fas fa-directions fa-2x"></i>
            </span>
          </label>
          <app-google-maps-search (setAddress)="getPickUpAddress($event)" addressType="geocode"
            [control]="businessSaleForm.get('pickUpAddress')">
          </app-google-maps-search>
        </div>
        <div class="col-48 grid-element" *ngIf="showProductValue">
          <label>PRODOTTO Value</label>
          <input type="number" formControlName="productValue" [readonly]="showProductValue">
        </div>
        <div class="col-48 grid-element" *ngIf="showDistanceInput">
          <label>Distance<b>(Km)</b></label>
          <input type="number" formControlName="distance" [readonly]="true" [disabled]="true">
        </div>
        <div class="col-48 grid-element" *ngIf="(groups.includes('admin') || (groups.includes('operation') && (selectedService?.service?.pricingModel?.toLowerCase() === 'sales')))">
          <label>Prezzo
            <b>{{ showStartEndTime ? "(Worked Hours * Servizio Prezzo)" : "" }}</b>
            <b>{{ showProductValue ? "(Fee % * Product Value)" : "" }}</b>
          </label>
          <input type="text" formControlName="price" [readonly]="true" [disabled]="true">
        </div>
        <div class="col-48 grid-element" *ngIf="(groups.includes('admin') || groups.includes('operation'))">
          <label>Plus Prezzo</label>
          <input type="number" formControlName="additionalPrice" [readonly]="disableAdditionalPriceInput" [disabled]="disableAdditionalPriceInput">
        </div>

        <br class="clear">

        <!--Payable field-->
        <div class="col-48 grid-element" *ngIf="groups.includes('admin')">
          <label for="payable"></label>
          <label class="original-label">
            <input type="checkbox" name="payable" formControlName="payable" (change)="handlePayable($event)">
            DA PAGARE
          </label>
        </div>
        <!--Payable field-->

        <br class="clear">

        <div class="col-48 grid-element" *ngIf="groups.includes('admin')">
          <label>VALET SALARIO</label>
          <input type="number" formControlName="expertSalary" [readonly]="true" [disabled]="true">
        </div>

        <div class="col-48 grid-element" *ngIf="groups.includes('admin')">
          <label>VALET SALARIO PLUS MINUS PREZZO</label>
          <input type="number" formControlName="valetAdditionalPrice" [readonly]="disableValetAdditionalPriceInput" [disabled]="disableValetAdditionalPriceInput">
        </div>
        
      </fieldset>
    </div>

    <div class="doc-notes-box" style="margin-top: 15px;">
      <fieldset>
        <legend>DOCUMENTAZIONE E NOTE:</legend>

        <div class="col-48 grid-element">
          <label>Numero DDT</label>
          <input type="text" formControlName="ddtNumber">
        </div>

        <div class="col-48 grid-element">
          <label>DDT</label>
          <div>
          </div>
          <input type="file" name="ddtFile" (change)="onFileSelect($event)" />
        </div>

        <div class="grid-element-full">
          <label>Note</label>
          <textarea rows="5" placeholder="Scrivi una nota" class="textarea" formControlName="notes"></textarea>
        </div>

        <div class="grid-element-full">
          <label>PERSONALIZZAZIONE</label>
          <textarea rows="5" placeholder="" class="textarea" formControlName="personalizeSaleNotes"></textarea>
        </div>

        <div class="grid-element-full" *ngIf="groups.includes('admin') || groups.includes('operation')">
          <label>Note interne</label>
          <textarea rows="5" placeholder="Scrivi una nota interna" class="textarea" formControlName="internalNotes"></textarea>
        </div>

      </fieldset>
    </div>
    <div class="error-box" style="margin-top: 15px;" *ngIf="getErrorMessages().length > 0">
      <fieldset>
        <legend>CAMPI OBBLIGATORI:</legend>
        <div>
          <ul class="error-list">
            <li *ngFor="let error of getErrorMessages()">
              {{ translateErrorMessage(error) }}
            </li>
          </ul>
        </div>
      </fieldset>
    </div>
  </form>
</div>
<div mat-dialog-actions>
  <div class="btn-submit">
    <button *ngIf="groups.includes('admin') || groups.includes('operation')" mat-button class="btn" (click)=onSubmit() [disabled]="!businessSaleForm?.valid || tmpBtnDisabled">Creare Consegna<i class="ml-10 far fa-save"></i>
    </button>
  </div>
</div>